var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconography/lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NiceFilmLab",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart-sidebar",
    transform: "translate(-67.000000, -550.000000)",
    stroke: "#3A2F29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(35.000000, 535.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography/lock",
    transform: "translate(32.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,6.5 L12.5,6.5 C14.1568542,6.5 15.5,7.84314575 15.5,9.5 L15.5,13.5 C15.5,15.1568542 14.1568542,16.5 12.5,16.5 L3.5,16.5 C1.84314575,16.5 0.5,15.1568542 0.5,13.5 L0.5,9.5 C0.5,7.84314575 1.84314575,6.5 3.5,6.5 Z",
    id: "Current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.000000, 11.500000) scale(-1, 1) rotate(-180.000000) translate(-8.000000, -11.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0.5 L11.5,0.5 L11.5,3 C11.5,4.93299662 9.93299662,6.5 8,6.5 C6.06700338,6.5 4.5,4.93299662 4.5,3 L4.5,0.5 L4.5,0.5 Z",
    id: "Current-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.000000, 3.500000) scale(-1, 1) rotate(-180.000000) translate(-8.000000, -3.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11.5,
    x2: 8,
    y2: 16.5,
    id: "Line-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3A2F29",
    x: 7,
    y: 11,
    width: 2,
    height: 2,
    rx: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.316d6c7b.svg";
export { ForwardRef as ReactComponent };